import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton, IconButton, Paper } from 'material-ui';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import moment from 'moment';
import R from 'ramda';

import CreditCardDisplay from '../../tc-ui/CreditCard';
import CancelReason from './cancel-reason';

import CreditCardForm from '../../tc-ui/CreditCardForm';
import InvoiceTable from './invoice-table';

import { cancelSubscription as cancelSubscriptionAction, getBilling, resetBillingError, updatePaymentSource } from '../../../stores/billing/billing-actions';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';

class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditCardDialogOpen: false,
      cancelDialogOpen: false,
      cancellationReason: null,
      addtionalDetail: '',
      invoicesDialogOpen: false,
      singleInvoice: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getBilling());
    dispatch({ type: '{billing} getInvoices' });
  }

  handleCloseCancelDialog =() => {
    this.setState({ cancelDialogOpen: false });
  }

  handleOpenCancelDialog =() => {
    this.setState({ cancelDialogOpen: true });
  }

  handleCancelReasonChange = (e, key, payload) =>
    this.setState({ cancellationReason: payload });

  handleAdditionalDetailsChange = (event, value) =>
    this.setState({ addtionalDetail: value });

  handleCancelSubscription = () => this.props.cancelSubscription(this.state.cancellationReason, this.state.addtionalDetail);

  toggleInvoiceDialog = () => {
    this.setState({
      invoicesDialogOpen: !this.state.invoicesDialogOpen,
    });
  };
  openOneInvoice = inv => () => this.setState({ singleInvoice: inv });
  backToInvoiceList = () => this.setState({ singleInvoice: null });
  render() {
    const {
      billing,
      user: { company: { plan } },
    } = this.props;
    const dateFormat = 'DD MMM YYYY';
    const currentPeriodEnd = moment(billing.currentPeriodEnd).format(dateFormat);
    const billingSubscriptions = R.propOr([], 'billingSubscriptions', billing);
    return (
      <div>
        <Paper
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            padding: '24px',
            marginBottom: '16px',
          }}
        >
          <div style={{ verticalAlign: 'top', width: 'calc(100% - 300px)' }}>
            {
              (() => {
                if (billing && billing.billingSubscriptions && billing.billingSubscriptions.length) {
                  return billing.billingSubscriptions.reduce((result, sub) => {
                    return [
                      ...result,
                      ...sub.items.map(item => ({ ...sub, ...item })),
                    ];
                  }, []).map((obj, i) => (
                    <p key={i}>
                      <div>
                        <b>{obj.plan.nickname || obj.plan.name}</b>
                      </div>
                      <small>
                        Current billing cycle started on {
                          moment(obj.currentPeriodEnd)
                            .subtract(obj.plan.interval_count, obj.plan.interval)
                            .format(dateFormat)
                        }
                      </small>
                    </p>
                  ));
                }
                return (
                  <div>
                    <h4 style={{ fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' }}>{plan} Plan</h4>
                    {
                      (billing.status === 'trialing' || !billing.cancelAtPeriodEnd) && (
                      <p>
                        <strong>{`${billing.status === 'trialing' ? 'Your trial expires' : 'Renews'} on ${currentPeriodEnd}`}</strong>
                      </p>)
                    }
                    {
                      billing.cancelAtPeriodEnd && (<p>
                        Your plan will not auto-renew and will end on {currentPeriodEnd}
                      </p>)
                    }
                    <span style={{ fontSize: '12px' }}>Note: All users on the admin team will receive billing emails.</span>
                  </div>
                );
              })()
            }
          </div>
          <div style={{ verticalAlign: 'top', padding: '0 10px' }}>
            {billing && billing.cardNumber && <div>
              <CreditCardDisplay
                cardType={billing.cardBrand}
                cardNumber={billing.cardNumber}
                cardExpYear={billing.cardExpYear}
                cardExpMonth={billing.cardExpMonth}
                nameOnCard={billing.nameOnCard}
              />
                <p style={{ textAlign: 'center' }}>
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      creditCardDialogOpen: !this.state.creditCardDialogOpen,
                    });
                  }}
                  >Update Credit Card</a>
                </p>
            </div>}
            {!billing || !billing.cardNumber && <div>
              <h4 style={{ fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' }}>Payment Method</h4>
              <p>
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  this.props.dispatch(resetBillingError());
                  this.setState({
                    creditCardDialogOpen: !this.state.creditCardDialogOpen,
                  });
                }}
                >Add Payment Information</a>
              </p>
            </div>
            }
          </div>
        </Paper>
        <Paper
          style={{
            padding: '24px',
            marginBottom: '16px',
            display: billing && billing.billingSubscriptions && billingSubscriptions.length ? 'block' : 'none',
          }}
        >
          <div className="flex-tc-sb">
            <h4 style={{ fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' }}>Upcoming Invoice</h4>
            {
              Boolean(billing.invoices && billing.invoices.length) && (
                <FlatButton
                  label="Invoice History"
                  secondary
                  labelStyle={{ textTransform: 'none' }}
                  onClick={this.toggleInvoiceDialog}
                />
              )
            }
          </div>
          {
            (() => {
              if (billing && billing.nextInvoice) {
                return (
                  <div>
                    <div style={{ margin: '16px 0' }}>
                      This is a preview of the invoice that will be billed on {currentPeriodEnd}. It may change if the subscription is updated.
                    </div>
                    <InvoiceTable invoice={billing.nextInvoice}/>
                  </div>
                );
              }
              return (
                <p>
                  No Upcoming Invoice
                </p>
              );
            })()
          }
        </Paper>
        {(billing.status !== 'trialing' && !billing.cancelAtPeriodEnd) && <Paper style={{ padding: '25px', marginBottom: '15px', textAlign: 'center' }}>
          <p>
            You are able to cancel your subscription at any time. When you cancel, your subscription will not renew and will end on {currentPeriodEnd}.
              <br/>
              <br/>
              <FlatButton
                secondary
                onClick={this.handleOpenCancelDialog}
              >
                Cancel Subscription
              </FlatButton>
              <CancelReason
                cancellationReason={this.state.cancellationReason}
                cancellationError={billing.errorMessage}
                submitDisabled={billing.isLoading}
                isOpen={this.state.cancelDialogOpen}
                onAdditionalDetailsChange={this.handleAdditionalDetailsChange}
                onSubmitClick={this.handleCancelSubscription}
                onCloseClick={this.handleCloseCancelDialog}
                onCancelReasonChange={this.handleCancelReasonChange}
              />
          </p>
        </Paper>}
        <Dialog
          contentStyle={{ borderRadius: '20px' }}
          titleStye={{ borderBottom: '50px solid #000000' }}
          modal
          open={this.state.creditCardDialogOpen}
          onRequestClose={() => {
            this.setState({
              creditCardDialogOpen: !this.state.creditCardDialogOpen,
            });
          }}
        >
          {this.props.billing.errorMessage &&
            <p style={{
              color: '#ff5e5c',
              lineHeight: '18px',
              marginBottom: '12px',
              borderRadius: '4px',
              background: '#fff5f5',
              padding: '16px 23px 16px 16px',
              fontSize: '12px',
            }}
            >
              {this.props.billing.errorMessage}
            </p>
          }
          <CreditCardForm
            buttonText="Update Card"
            stripePublicKey={process.env.STRIPE_PUBLIC_KEY}
            buttonStyle={{ display: 'block', margin: '40px auto 25px auto' }}
            containerStyle={{ width: '100%' }} inputFieldStyle={{ verticalAlign: 'top' }}
            submitDisabled={billing.isLoading}
            isProcessing={billing.isLoading}
            onCreateToken={(status, response) => {
              if (status === 200) {
                this.props.dispatch(updatePaymentSource(response.id))
                  .then(() => {
                    this.setState({
                      creditCardDialogOpen: false,
                    });
                    this.props.dispatch(resetBillingError());
                  })
                  .catch((err) => {
                    console.log('err', err);
                  });
              } else {
                console.log('onCreateTokenStatus', status);
                console.log('Response', response);
              }
            }}
          />
        {!billing.isLoading && <a
          style={{ display: 'block', textAlign: 'center' }}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ creditCardDialogOpen: false });
          }}
        >Cancel</a> }
        </Dialog>
        <Dialog
          contentStyle={{ borderRadius: '20px' }}
          open={this.state.invoicesDialogOpen}
          onRequestClose={this.toggleInvoiceDialog}
          title={(
            <div className="flex-tc-sb">
              {
                this.state.singleInvoice
                  ? (
                    <FlatButton
                      icon={<ChevronLeft/>}
                      label="Back To List"
                      onClick={this.backToInvoiceList}
                    />
                  )
                  : (
                    <div style={{ fontSize: '20px' }}>Invoice History</div>
                  )
              }
              <IconButton onClick={this.toggleInvoiceDialog}>
                <CloseIcon style={{ fontSize: '16px' }}/>
              </IconButton>
            </div>
          )}
        >
          {
            this.state.singleInvoice ? (
              <div style={{ fontSize: '14px' }}>
                <InvoiceTable invoice={this.state.singleInvoice} />
                {
                  Boolean(this.state.singleInvoice.invoice_pdf) && (
                    <div
                      style={{ textAlign: 'center', cursor: 'pointer', color: '#00bcd4', marginTop: '8px' }}
                      onClick={() => {
                        if (this.state.singleInvoice.invoice_pdf) window.open(this.state.singleInvoice.invoice_pdf);
                        else window.alert(`Only finalized invoices have PDF.`);
                      }}
                    >
                      Download
                    </div>
                  )
                }
              </div>
            ) : (
              <div>
                <div
                  style={{
                    display: 'flex',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                    borderBottom: '1px solid #e0e0e0',
                  }}
                >
                  <div style={{ width: '100px', textAlign: 'right' }}>
                    AMOUNT
                  </div>
                  <div style={{ width: '72px' }}/>
                  <div style={{ flex: 1, textAlign: 'center' }}>
                    INVOICE NUMBER
                  </div>
                  <div style={{ flex: 1, textAlign: 'center' }}>
                    FINALIZED DATE
                  </div>
                  <div style={{ flex: 1 }}/>
                </div>
                {
                  billing.invoices.map((inv, i) => (
                    <div
                      key={i}
                      style={{
                        display: 'flex',
                        borderBottom: '1px solid #e0e0e0',
                        fontSize: '12px',
                        padding: '4px',
                        cursor: 'pointer',
                      }}
                      onClick={this.openOneInvoice(inv)}
                    >
                      <div style={{ width: '100px', paddingRight: '4px', textAlign: 'right' }}>
                        ${(inv.total / 100).toFixed(2)}
                      </div>
                      <div style={{ width: '72px' }}>
                        {inv.currency.toUpperCase()}
                      </div>
                      <div style={{ flex: 1, textAlign: 'center' }}>
                        {inv.number}
                      </div>
                      <div style={{ flex: 1, textAlign: 'center' }}>
                        {inv.finalized_at ? moment(inv.finalized_at * 1000).format(dateFormat) : 'pending'}
                      </div>
                      <div
                        style={{ flex: 1, textAlign: 'center', cursor: 'pointer', color: '#00bcd4' }}
                        onClick={() => {
                          if (inv.invoice_pdf) window.open(inv.invoice_pdf);
                          else window.alert(`Only finalized invoices have PDF.`);
                        }}
                      >
                        Download
                      </div>
                    </div>
                  ))
                }
                {
                  Boolean(billing.hasMoreInvoices) && (
                    <small>Showing the most recent 25 invoices only.</small>
                  )
                }
              </div>
            )
          }
        </Dialog>
      </div>
    );
  }
}

Billing.propTypes = {
  billing: PropTypes.object,
  cancelSubscription: PropTypes.func,
  children: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  user: PropTypes.object,
};

const mapDispatchToProps = ({
  cancelSubscription: cancelSubscriptionAction,
});

export default connect(null, mapDispatchToProps)(Billing);



// WEBPACK FOOTER //
// ./src/app/components/settings/billing/index.jsx